import { checkSitepresence, countAlarms, endSitepresence } from '@/utils/requestHandler'

export default {
   name: 'RemoveSitePresence',

   data() {
      return {
         code: null,
         loading: true, // true während API-Request
         canCheckout: false,
         doneCheckout: false,
         successCheckout: false,
         countAlarms: -1,
      }
   },

   methods: {

      async checkCheckout() {
         this.loading = true
         await this.countAlarmsApi()
         if (this.countAlarms === 0){
            await this.endSitepresenceApi()
         }
         this.loading = false
      },

      buildCheckSitepresence() {
         return {
            location: this.code,
            userEmail: localStorage.getItem('user_email')
         }
      },

      buildEndSitepresence() {
         return {
            location: this.code,
            userID: localStorage.getItem('user_name'),
            userEmail: localStorage.getItem('user_email')
         }
      },

      async checkSitepresenceApi() {
         this.loading = true
         try {
            const sitepresence = this.buildCheckSitepresence()
            const queryString = require('querystringify')
            const sitepresenceURL = queryString.stringify(sitepresence, true)

            const response = await checkSitepresence(sitepresenceURL)
            this.canCheckout = response && response.data === true
            console.log('checkSitepresence response:', response && response.data)

            if (this.canCheckout) {
               await this.countAlarmsApi()
            }
         } catch (e) {
            console.error('Fehler beim Prüfen der Sitepresence:', e)
            this.canCheckout = false
         } finally {
            this.loading = false
         }
      },

      async countAlarmsApi() {
                                try {
                                   const sitepresence = this.buildCheckSitepresence()
                                   const queryString = require('querystringify')
                                   const sitepresenceURL = queryString.stringify(sitepresence, true)

                                   const response = await countAlarms(sitepresenceURL)
                                   this.countAlarms = response && response.data
                                   console.log('alarm count response:', response && response.data)
                                } catch (e) {
                                   console.error('Fehler beim Prüfen der Alarm Counts:', e)
                                   this.countAlarms = -1
                                }
                             },

      async endSitepresenceApi() {
         this.loading = true
         try {
            const sitepresence = this.buildEndSitepresence()
            const queryString = require('querystringify')
            const sitepresenceURL = queryString.stringify(sitepresence, true)

            const response = await endSitepresence(sitepresenceURL)
            this.successCheckout = response && response.data === true
            console.log('endSitepresence response:', response && response.data)
         } catch (e) {
            console.error('Fehler beim Beenden der Sitepresence:', e)
            this.successCheckout = false
         } finally {
            this.loading = false
            this.doneCheckout = true
         }
      }
   },

   async mounted() {
      // code aus route params holen
      this.code = this.$route.params.code

      // sofort beim Laden prüfen
      await this.checkSitepresenceApi()
   }
}
